import { FunctionComponent } from 'react'

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  color?: 'white' | 'gray'
}

export const Spinner: FunctionComponent<SpinnerProps> = ({ size = 'md', color = 'white' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  const colorClasses = {
    white: 'border-white',
    gray: 'border-gray-400',
  }

  return (
    <div
      className={`${sizeClasses[size]} ${colorClasses[color]} border-2 border-t-transparent rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
    />
  )
}
